import SidebarTree from './component'

export default SidebarTree
